import type { FaireProductEntity } from "../../entity_types/product";

export const p_3swnkt8tya: FaireProductEntity = {
  token: "p_3swnkt8tya",
  type: "product",
  name: "Lemon & Garlic Pasture-Raised Chicken Bone Broth 14oz",
  brandToken: "b_3nwax652hv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ece0b55b63c1aba914875d401a0e5d4f33d1b7124033ef56f1fc71b7e36d649f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ee430cbff6ee170aaf45294865a9c577ce0a148d7f263bd27c3ac16f61e50b2.png",
    "https://cdn.faire.com/fastly/0e5b797bdf905187089a468493ffc5105b2a16b9060009ab7c267457a867843c.png",
    "https://cdn.faire.com/fastly/03cc84a50dcae95c05e78cc81612d7ef4ca5d95749d33ea2799cd51dfbaaf987.png",
  ],
  priceDollars: 8.31,
  description:
    'Lemon, garlic, radish, and onion combine to make this bone broth tonic bright and tangy. Try sipping it all on its own or use it in any recipe that calls for garlic and onion, from rice to sauces and soups to stews! It’s our number one recommendation for cooking! It even shines in a Bloody Mary. \n\nA note on our sourcing: we only use pasture-raised regenerative bones and organic herbs and veggies - no hormones, GMOs, added sugar, antibiotics or preservatives. From brew to jar, we also utilize a 100% plastic-free process, and all of our broths are shelf-stable!\n\nSold in packs of 4 - trust us, you’ll go through it faster than you think!\n\n"Love, Love , LOVE!!! You have got to try this magical broth. It makes my mouth and body happy!" - Patti L.',
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:20.352Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
